import React from 'react'
import { ipfsToHttp } from '../utils/formatting'

export interface IpfsImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  /** The image source - can be an ipfs:// URI or regular URL */
  src: string
}

/**
 * An image component that automatically converts IPFS URIs to gateway URLs.
 * 
 * @example
 * <IpfsImage src="ipfs://QmHash123" alt="IPFS image" />
 */
export const IpfsImage = ({ src, ...props }: IpfsImageProps) => {
  const finalSrc = ipfsToHttp(src) || src
  return <img src={finalSrc} {...props} />
}

export default IpfsImage

